import { Avatar, Button, Dialog, DialogContent, DialogContentText, IconButton, styled } from "@mui/material";
import apiManagerEvent from "api/manager-event";
import apiManagerStorage from "api/manager-storage";
import apiManagerUser from "api/manager-users";
import CustomerSupport from "components/CustomerSupport";
import OtpDialog from "components/Dialog/OtpDialog";
import { DIALOG_ID } from "components/Dialog/constant";
import { TooltipCC } from "components/common";
import { COMPONENT_RENDER, DRAG_ID } from "constants/common";
import { TOAST_CONFIG, TOAST_POSITION } from "constants/toast";
import { MainLayout } from "layouts";
import moment from "moment";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { batch, useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Slide } from "react-slideshow-image";
import 'react-slideshow-image/dist/styles.css';
import { setEmail } from "store/user/accountInfo";
import { setUserInfo } from "store/user/userInfoSlice";
import { endSession, establishSession } from 'store/sessionSlice';
import { localLog } from "utils/functions/common";
import { renderTitleNotification } from "utils/functions/notification";
import { getUserProperty, setOpenDialogCC, toastInfoInvite, toastInfoInviteUsingStorage, toastSuccess } from "utils/helpers";
import avatarDefault from "../../src/assets/img/favicon.png";
import socket from "../api/websocket/socket";
import '../components/Layout/Layout.css';
import '../components/common/style.css';
import { API_DOMAIN, PAGE_DOMAIN } from "../constants/api";
import { setCloseModal, setOpenModal } from '../store/modal/modalSlice';
import { setStateModalDetail } from "./manager-meeting/modelPeriodSlice";
import { appendListAssign, filterListAssign, setEmailAssign, setLiceseCode, setListAssign, setNamePackageAssign } from "./service-package-management/store/packageManagementSlice";
import { IconClose } from "assets/icons";
import { USER_PROPERTIES } from "constants/user";

const DialogCC = styled(Dialog)({
    '& .MuiDialogContent-root': {
        minWidth: '600px !important',
        maxWidth: '800px !important',
        width: '800px',
        overflowY: "hidden",
        padding: '0px'
    }
})

export default function Main() {
    const { t } = useTranslation();
    const DaysConvertToSecond = 30 * 24 * 60 * 60;
    const userInfo = useSelector((state) => state.userInfo.userInfo);
    const refTimeout = useRef();
    const isOpenModalDetail = useSelector((state) => state.modelPeriod.isOpenModalDetail);

    // const openModalCancel = useSelector((state) => state.modelPeriod.isOpenModalCancel);
    const roomId = useSelector((state) => state.modelPeriod.roomId);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [location, setLocation] = useSearchParams();
    const { isResponse } = useSelector((state) => state.packageManagement);
    // const [touchStart, setTouchStart] = useState(null)
    // const [touchEnd, setTouchEnd] = useState(null)
    const [eventApply, setEventApply] = useState([])
    const [checkListAvatar, setCheckListAvatar] = useState(0)
    const [open, setOpen] = useState(false);
    // const [openSupport, setOpenSupport] = useState(false);
    const [checkCoutLogin, setCheckCoutLogin] = useState(localStorage.getItem("checkEventPopupByUser"))
    const [bottomSupportCmp, setBottomSupportCmp] = useState(30)
    const [rightSupportCmp, setRightSupportCmp] = useState(25)
    const username = getUserProperty(USER_PROPERTIES.USERNAME)

    useEffect(() => {
        setCheckCoutLogin(localStorage.getItem("checkEventPopupByUser"))
    }, []);

    const handleClickOpen = () => {
        setOpen(!open);
    };

    // const contactSupport = () => {
    //     setOpenSupport(!openSupport)
    // }

    const handleClose = () => {
        localStorage.setItem("checkEventPopupByUser", 0)
        setCheckCoutLogin(0)
        setOpen(false);
    };

    const handleRedirectEvent = (event) => {
        let opneLinkEvent = event?.eventLink
        window.open(opneLinkEvent, '_blank')
    }


    // the required distance between touchStart and touchEnd to be detected as a swipe
    // const minSwipeDistance = 50

    // const onTouchStart = (e) => {
    //     setTouchEnd(null) // otherwise the swipe is fired even with usual touch events
    //     setTouchStart(e.targetTouches[0].clientX)
    // }

    // const onTouchMove = (e) => setTouchEnd(e.targetTouches[0].clientX)

    // const onTouchEnd = () => {
    // if (!touchStart || !touchEnd) return
    // const distance = touchStart - touchEnd
    // const isLeftSwipe = distance > minSwipeDistance
    // const isRightSwipe = distance < -minSwipeDistance
    // if (isLeftSwipe || isRightSwipe) console.log('swipe', isLeftSwipe ? 'left' : 'right')
    // if (isRightSwipe) navigate(-1)
    // add your conditional logic here
    // }

    const verifyMail = (email, beforeEmail, otp) => {
        return apiManagerUser.verifyMail(email, beforeEmail, otp)
    }

    const getMyInviteLicense = () => {
        return apiManagerUser.getMyInviteLicense()
    }

    const handleSubmitVerifyOtp = (emailAccount, beforeEmailAccount, otp) => {
        verifyMail(emailAccount, '', otp)
            .then(res => {
                toastSuccess(t('toast.verifiedEmail'));
                dispatch(setUserInfo({
                    ...userInfo,
                    email: emailAccount
                }))
                dispatch(setCloseModal());
            })
            .catch(error => {
                dispatch(setCloseModal());
            })
    }

    const contentToastInvite = () => {
        return (
            <div dangerouslySetInnerHTML={{ __html: `${t('toast.contentInvite')}` }}></div>
        )
    }

    const getListInvitations = () => {
        return apiManagerStorage.getListInvitations();
    }

    useEffect(() => {
        // Listen newest socket
        socket.on("invite_package_event", function (message) {
            if (message) {
                if (window.location.pathname !== "/profile-user") {
                    toastInfoInvite(t('toast.titleInvite'), contentToastInvite(), { autoClose: false, toastId: "toast_id_invite_package" }, dispatch, navigate)
                }
                dispatch(appendListAssign(message))
            }
        });
        // Listen newest socket
        socket.on("unassign_package_event", function (message) {
            if (message) {
                dispatch(filterListAssign(message?.license_code))
            }
        });

        if (username) {
            getMyInviteLicense()
                .then(res => {
                    if (res.data?.license !== 0) { // Thay đổi api
                        if (window.location.pathname !== "/profile-user") {
                            toastInfoInvite(t('toast.titleInvite'), contentToastInvite(), { autoClose: false }, dispatch, navigate)
                        }
                        batch(() => {
                            dispatch(setListAssign(res.data?.license))
                            dispatch(setEmailAssign(res.data?.license?.accountEmail))
                            dispatch(setNamePackageAssign(res.data?.license?.product_package_name))
                            dispatch(setLiceseCode(res.data?.license?.license_code))
                        })
                    } else {
                        dispatch(setListAssign([]))
                    }
                })
                .catch(err => {
                    console.log("err: ", err)
                })

            getListInvitations()
                .then(result => {
                    if (result?.length > 0) {
                        if (window.location.pathname !== "/manager-storage") {
                            const { title, content } = renderTitleNotification(12)
                            toastInfoInviteUsingStorage(title, content, { ...TOAST_CONFIG, position: TOAST_POSITION.topCenter, autoClose: false }, navigate)
                        }
                    }
                })
                .catch(error => {
                })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isResponse])

    useEffect(() => {
        function hideInfoAttachFiles(e) {
            if (e.key === 'Escape') {
                batch(() => {
                    dispatch(setCloseModal());
                    dispatch(setStateModalDetail({ isOpenModalDetail: false, roomId: '' }));
                })
            }
        }
        window.addEventListener('keydown', hideInfoAttachFiles);
        return () => {
            window.addEventListener('keydown', hideInfoAttachFiles);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        document.addEventListener("keydown", (event) => {
            if (event.key === "Enter" && event.ctrlKey) {
                event.preventDefault();
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (userInfo?.verifyMail) {
            batch(() => {
                refTimeout.current = setTimeout(() => {
                    dispatch(setEmail(userInfo?.email))
                    if ((moment().unix() - parseInt(userInfo?.timeMustVerifyMail) > parseInt(DaysConvertToSecond))) {
                        dispatch(setOpenModal({ modal: <OtpDialog onSubmitVerifyOtp={handleSubmitVerifyOtp} componentRender={COMPONENT_RENDER.VERIFY_EMAIL} checkClose={true} />, alwayClose: false }))
                    } else {
                        dispatch(setOpenModal({ modal: <OtpDialog onSubmitVerifyOtp={handleSubmitVerifyOtp} componentRender={COMPONENT_RENDER.VERIFY_EMAIL} checkClose={false} />, alwayClose: true }))
                    }
                }, 3000)
            })
        } else {
            clearTimeout(refTimeout.current)
            const username = userInfo?.username
            if (localStorage.getItem(`timeVerifyEmail_${username}`)) {
                localStorage.removeItem(`timeVerifyEmail_${username}`);
            }
        }
        return () => {
            refTimeout.current = null;
            // dispatch(setCloseModal());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userInfo?.verifyMail])

    useEffect(() => {
        isOpenModalDetail && navigate(`/manager-meeting/details/${roomId}`)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpenModalDetail])

    useEffect(() => {
        localLog("socketsocket", socket, socket?.connected)
        const handleRemoteLogout = (message) => {
            localLog("logout_event: ", message)
            dispatch(endSession());
            window.location.href = `${PAGE_DOMAIN}login`;
        };
        socket.on("logout_event", handleRemoteLogout);
        return () => socket.off("logout_event", handleRemoteLogout);
    }, [dispatch])

    const videoRef = useRef(null)
    useLayoutEffect(() => {
        if (videoRef.current && open) {
            videoRef.current.play();
        }
    }, [open])

    useEffect(() => {
        if (checkCoutLogin === 0) {
            apiManagerEvent.getListEventAdmin()
                .then(async (r) => {
                    if (r.status === 200) {
                        let listEvent = r.data.data
                        if (listEvent.length > 0) {
                            setEventApply(listEvent.map(eventActive => {
                                setOpen(false)
                                const backgroundExtension = eventActive.background.split('.').pop().toLowerCase()
                                let backgroundType = null;
                                if (backgroundExtension === 'jpg' || backgroundExtension === 'jpeg' || backgroundExtension === 'gif' || backgroundExtension === 'png') {
                                    backgroundType = 'image'
                                } else if (backgroundExtension === "mp4") {
                                    backgroundType = 'video';
                                }
                                return {
                                    ...eventActive,
                                    avatar: (eventActive.avatar === "undefined" || eventActive.avatar === '' || eventActive.avatar === undefined || eventActive.avatar === null) ? null : API_DOMAIN + eventActive.avatar,
                                    background: API_DOMAIN + eventActive.background,
                                    backgroundType: backgroundType
                                }
                            }

                            ))
                            let countAvatarEvent = listEvent.filter(e => e.avatar !== undefined && e.avatar !== "undefined" && e.avatar !== null).length
                            setCheckListAvatar(countAvatarEvent)
                        }
                    }
                })
                .catch((error) => {
                });
        }
        if (checkCoutLogin === 1) {
            apiManagerEvent.getListEventAdmin()
                .then(async (r) => {
                    if (r.status === 200) {
                        let listEvent = r.data.data
                        if (listEvent.length > 0) {
                            setEventApply(listEvent.map(eventActive => {
                                setOpen(true)
                                const backgroundExtension = eventActive.background.split('.').pop().toLowerCase()
                                let backgroundType = null;
                                if (backgroundExtension === 'jpg' || backgroundExtension === 'jpeg' || backgroundExtension === 'gif' || backgroundExtension === 'png') {
                                    backgroundType = 'image'
                                } else if (backgroundExtension === "mp4") {
                                    backgroundType = 'video';
                                }
                                return {
                                    ...eventActive,
                                    avatar: (eventActive.avatar === "undefined" || eventActive.avatar === '' || eventActive.avatar === undefined || eventActive.avatar === null) ? null : API_DOMAIN + eventActive.avatar,
                                    background: API_DOMAIN + eventActive.background,
                                    backgroundType: backgroundType
                                }
                            }

                            ))
                            let countAvatarEvent = listEvent.filter(e => e.avatar !== undefined && e.avatar !== "undefined" && e.avatar !== null).length
                            setCheckListAvatar(countAvatarEvent)
                        }
                    }
                })
                .catch((error) => {
                });
        }

    }, [checkCoutLogin])

    const properties = {
        duration: 3000,
        autoplay: true,
        transitionDuration: 1000,
        arrows: true,
        infinite: true,
        indicators: false,
        pauseOnHover: true,
        canSwipe: true,
        easing: "cubic",
        cssClass: "height: 70px, width: 100px"
    };

    useEffect(() => {
        const nextParams = new URLSearchParams(location);
        let shouldReplaceParams = false;

        if (location.get("token") && location.get("refresh_token")) {
            const accessToken = location.get("token");
            const refreshToken = location.get("refresh_token");
            dispatch(establishSession({ accessToken, refreshToken }));

            nextParams.delete('token');
            nextParams.delete('refresh_token');
            shouldReplaceParams = true;
        }

        if (location.get("provide-service") === "true") {
            setOpenDialogCC({ id: DIALOG_ID.PROVIDE_SERVICE })
            nextParams.delete('provide-service');
            shouldReplaceParams = true;
        }

        if (shouldReplaceParams) setLocation(nextParams, { replace: true });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location])

    return (
        <div
            // onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd}
            onDrop={(e) => {
                e.preventDefault()
                // Kiem tra ID component drag
                if (e.dataTransfer.getData(DRAG_ID.ID) === DRAG_ID.CUSTOMER_SUPPORT) {
                    setBottomSupportCmp(window.innerHeight - e.pageY)
                    setRightSupportCmp(window.innerWidth - e.pageX)
                }
            }}
            onDragEnter={(e) => {
                e.preventDefault()
            }}
            onDragOver={(e) => e.preventDefault()}
        >
            <div>
                <CustomerSupport bottom={bottomSupportCmp} right={rightSupportCmp} />
                {/* <div style = {{display: "flex", flexDirection: "row", alignItems: "center", justifyContent: 'flex-end', gap: "10px", position: "fixed", width: 'fit-content', height: '50px',  zIndex: '10000', bottom: '30px', right: '25px',}}>
                    {  openSupport === true &&
                        <span style={{ display: 'flex', alignItems: 'center', padding: '10px', backgroundColor: '#F2F2F2', borderRadius: '20px',  width: "fit-content", height: '50px', fontWeight: '600'}}>{t('toast.contactSupport')}</span>
                    }
                    <Avatar src = {imgSupport}  variant="rounded"  sx={{ cursor: "pointer", backgroundColor: "transparent",  width: "50px", height: '50px'}} onClick={contactSupport}></Avatar>
                </div> */}
                {
                    (eventApply.length > 1 && checkListAvatar >= 1) &&
                    <Avatar src={avatarDefault} variant="rounded" sx={{ cursor: "pointer", objectFit: 'contain !important', backgroundColor: "transparent", width: "50px", position: 'fixed', bottom: '100px', right: '25px', zIndex: '10000' }} onClick={handleClickOpen}></Avatar>
                }
                {
                    (eventApply.length === 1 && checkListAvatar === 1) &&
                    <Avatar src={eventApply[0].avatar} variant="rounded" sx={{ cursor: "pointer", objectFit: 'contain !important', width: "50px", height: '50px', backgroundColor: "transparent", position: 'fixed', bottom: '100px', right: '25px', zIndex: '10000' }} onClick={handleClickOpen}></Avatar>
                }
                {
                    <div>
                        {(checkCoutLogin === 1 || open === true)
                            ?
                            <DialogCC sx={{ width: '100%', height: '100%' }} open={open} modal={true} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description"
                                disableEscapeKeyDown={true} disableBackdropClick={true}
                                onClose={(event, reason) => { if (reason !== 'backdropClick') { handleClose(event, reason) } }}>
                                <DialogContent sx={{ padding: "0", backgroundColor: "transparent" }}>
                                    <TooltipCC title={t('dialog.close')}>
                                        <IconButton style={{ position: 'absolute', right: 0, top: 0, p: 0.5, m: 0.5, zIndex: 1000 }} aria-label="close" onClick={handleClose}><IconClose /></IconButton>
                                    </TooltipCC>
                                    <DialogContentText >
                                        {(eventApply.length === 1 && eventApply[0].backgroundType === 'image') &&
                                            <div className="each-slide-effect" >
                                                <div style={{ height: '500px', width: '800px !important', backgroundSize: 'cover', backgroundImage: `url(${eventApply[0].background})` }}>
                                                    {
                                                        (eventApply[0].eventLink && eventApply[0].labelButton) &&
                                                        <Button style={{ display: 'flex', alignItems: 'center', position: 'absolute', bottom: '10%' }} onClick={() => handleRedirectEvent(eventApply[0])}>{eventApply[0].labelButton}</Button>
                                                    }
                                                </div>
                                            </div>
                                        }
                                        {(eventApply.length === 1 && eventApply[0].backgroundType === 'video') &&
                                            <div className="each-slide-effect" >
                                                <div style={{ display: 'flex', backgroundRepeat: "no-repeat", overflow: "hidden", backgroundPosition: "center", backgroundSize: "cover", height: '100%', width: '100%', }}>
                                                    <video autoplay="autoplay" muted loop id="videoEventApply" style={{ width: "100%" }}>
                                                        <source src={eventApply[0].background} allowFullScreen type='video/mp4' />
                                                    </video>
                                                    {
                                                        (eventApply[0].eventLink && eventApply[0].labelButton) &&
                                                        <Button style={{ display: 'flex', alignItems: 'center', position: 'absolute', bottom: '10%' }} onClick={() => handleRedirectEvent(eventApply[0])}>{eventApply[0].labelButton}</Button>
                                                    }
                                                </div>
                                            </div>
                                        }
                                        {eventApply.length > 1 &&
                                            <Slide vertical={false} {...properties} autoplay={true}>
                                                {eventApply.map((event, index) => (
                                                    <div className="each-slide-effect" key={index}>
                                                        {event.backgroundType === "image" &&
                                                            <div style={{ height: '500px', width: '800px !important', backgroundImage: `url(${event.background})` }} >
                                                                {(event.eventLink && event.labelButton) &&
                                                                    <Button style={{ display: 'flex', alignItems: 'center', position: 'absolute', bottom: '10%' }} onClick={() => handleRedirectEvent(event)}>{event.labelButton}</Button>
                                                                }
                                                            </div>
                                                        }
                                                        {event.backgroundType === "video" &&
                                                            <div style={{ display: 'flex', backgroundRepeat: "no-repeat", position: 'relative', overflow: "hidden", backgroundPosition: "center", backgroundSize: "cover", maxHeight: '500px', width: '800px !important' }}>
                                                                <video autoplay="autoplay" muted loop id="videoEventApply" style={{ height: "500px", width: "100%", objectFit: 'cover' }}>
                                                                    <source src={event.background} allowFullScreen type='video/mp4' />
                                                                </video>
                                                                {(event.eventLink && event.labelButton) &&
                                                                    <Button style={{ display: 'flex', alignItems: 'center', position: 'absolute', bottom: '10%' }} onClick={() => handleRedirectEvent(event)}>{event.labelButton}</Button>
                                                                }
                                                            </div>
                                                        }
                                                    </div>
                                                ))
                                                }
                                            </Slide>
                                        }
                                    </DialogContentText>
                                </DialogContent>
                            </DialogCC>
                            : <></>
                        }
                    </div>
                }

            </div>
            <MainLayout />
            {/* <Grid container>
                <Grid item xs={12} className="appbar-cc" sx={{ height: SIZE_COMPONENT.HEADER_H }}>
                    <AppBarCC />
                </Grid>
                <Grid item xs={12} sx={{ height: { xs: `calc(100vh - ${theme.spacing(6)} - ${theme.spacing(6)})`, sm: `calc(100vh - ${SIZE_COMPONENT.HEADER_H})` } }}>
                    <Box sx={{ display: 'flex', height: 1 }}>
                        {!isMobile && <SidebarCC />}
                        <Box sx={{ flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column' }}>
                            <RequiredAuth />
                        </Box>
                    </Box>
                </Grid>
                {
                    isMobile && <BottomAppbar />
                }
            </Grid> */}
        </div>
    )
}
